import { useRouter } from 'next/router'
import Link from 'next/link'

import { historyUtils } from '@wartek-id/fe-toolbox'
import { Icon } from '@wartek-id/icon-v2'
import { Popover, PopoverContent, PopoverTrigger } from '@wartek-id/popover'
import { List, ListItem } from '@wartek-id/list'

import { useApiCompetencyMappingResult } from 'api/competency-mapping/useAPICompetencyMapping'

import type { FC } from 'react'

interface ProfileHeaderBlendProps extends React.HTMLAttributes<HTMLDivElement> {
  classNameBgContainer?: string
  classNameSubContainer?: string
}

const ProfileHeaderBlend: FC<ProfileHeaderBlendProps> = ({
  className = '',
  classNameBgContainer = '',
  classNameSubContainer = '',
  children = '',
}) => {
  const router = useRouter()

  const assesmentType = 'SJT'
  const {
    data: UjikomDataCompetencyMappingResult,
    isSuccess: isSuccessCompetencyMappingResult,
  } = useApiCompetencyMappingResult(assesmentType, true)

  const doesHaveCertificate =
    UjikomDataCompetencyMappingResult?.metadata.state ===
      'FORM_CERTIFICATE_GENERATED' ||
    UjikomDataCompetencyMappingResult?.metadata.state === 'FORM_COMPLETED'

  return (
    <div className={className}>
      <div className={classNameBgContainer} />
      <div className={classNameSubContainer}>
        <div className="flex justify-between w-full p-4">
          <button
            aria-label="Kembali"
            onClick={() => {
              historyUtils.backToApp(() => router.push('/home'))
            }}
          >
            <Icon color="inverse">arrow_circle_left</Icon>
          </button>

          <Popover>
            <PopoverTrigger aria-label="Menu">
              <Icon color="inverse">pending</Icon>
            </PopoverTrigger>

            <PopoverContent>
              <List type="menu">
                <ListItem>
                  <Link href="/refleksi-kompetensi/onboarding?source=home">
                    Tentang Refleksi
                  </Link>
                </ListItem>
                <>
                  {isSuccessCompetencyMappingResult && doesHaveCertificate && (
                    <ListItem>
                      <Link href="/pemetaan-kompetensi/sertifikat?source=home">
                        Sertifikat
                      </Link>
                    </ListItem>
                  )}
                </>
              </List>
            </PopoverContent>
          </Popover>
        </div>
        {children}
      </div>
    </div>
  )
}
export default ProfileHeaderBlend
